'use strict'

import {
  Polymer
} from '@polymer/polymer/lib/legacy/polymer-fn.js'
import {
  dom,
  flush
} from '@polymer/polymer/lib/legacy/polymer.dom.js'
import {
  html
} from '@polymer/polymer/lib/utils/html-tag.js'

Polymer({
  is: 'moskito-song-chordpro',
  _template: html`
    <style>
      :host {
        display: block;
        margin: 20px 30px;
      }
      .chordpro-chords {
          font-family: 'Roboto Mono', monospace;
          white-space: pre;
          color: darkred;
      }
      .chordpro-lyrics {
          font-family: 'Roboto Mono', monospace;
          white-space: pre;
      }
      .chordpro-section {
          margin-top: 20px;
      }
      .chorus {
          margin-left: 40px;
      }
.align-right {
display: flex;
justify-content: flex-end;
}
      paper-toggle-button {
--paper-toggle-button-checked-bar-color: var(--paper-blue-a700);
--paper-toggle-button-checked-button-color: var(--paper-red-a700);
      }
    </style>
    <div class="chordpro-section">
      <div class="align-right">
        <paper-toggle-button checked={{french}}>[[_translate('Show French Scale Chords')]]</paper-toggle-button>
      </div>
      <template is="dom-repeat" items="{{chordpro}}">
        <div class="chordpro-chords">{{item.chords}}</div>
        <div class="chordpro-lyrics">{{item.lyrics}}</div>
      </template><br/>
      <div class="copyright">
        [[copyright.copyright]]
        <template is="dom-repeat" items="[[copyright.authors]]">
          [[item]]
        </template>&mdash;
        <template is="dom-repeat" items="[[copyright.publishers]]">
          [[item]]
        </template>
        &mdash;&nbsp;Reproduction interdite sans l'accord de LTC.
      </div>
    </div>
  `,
  properties: {
    lyrics: {
      type: String,
      notify: true
    },
    chordpro: {
      type: Array,
      notify: true,
      computed: 'renderHTML(lyrics, _chordParse, french)'
    },
    french: {
      type: Boolean,
      notify: true,
      observer: '_frenchChanged'
    },
    copyright: {
      type: Object,
      notify: true
    }
  },
  renderHTML: function (lyrics, chordParse, french) {
    const commentRgx = /\{[^{}]+\}|^\#.*/g // Anything between {curly braces} - single line - and Anything with '#'
    // Comment
    let lines = lyrics.split('\n')
    let sectArray = []
    const rgx = /\[[0-9A-Zm#b\/(sus)(aug)(min)(maj)(dim)]*\]/g
    lines.forEach(function (line, idx, arr) {
      if (line.match(commentRgx) == null) {
        if (line != null) {
          let d = 0
          let chordline = ''
          let preppedLine = line.replace(rgx, function (x) {
            return '|$|' + x + '|$|'
          })
          let lineArray = preppedLine.split('|$|')
          lineArray.forEach(function (el, ix, ar) {
            if (rgx.test(el)) {
              let j = d
              if (j < 0) j = 0
              let chord = chordParse(el, french)
              chordline += ' '.repeat(j)
              chordline += chord
              d = -chord.length + 2
            } else {
              d += el.length
            }
          })
          sectArray[idx] = {
            'chords': chordline,
            'lyrics': stripChords(line) + ' '
          }
        } else {
          sectArray[idx] = {
            'chords': '',
            'lyrics': stripChords(line) + ' '
          }
        }
      }
    })
    return sectArray
  },
  _chordParse: function (element, french) {
    let stripped = element.replace(/^\[|\]$/g, '')
    if (french) {
      switch (true) {
        case /^A/.test(stripped):
          stripped = stripped.replace(/^A/, 'La')
          break
        case /^B/.test(stripped):
          stripped = stripped.replace(/^B/, 'Si')
          break
        case /^C/.test(stripped):
          stripped = stripped.replace(/^C/, 'Do')
          break
        case /^D/.test(stripped):
          stripped = stripped.replace(/^D/, 'Ré')
          break
        case /^E/.test(stripped):
          stripped = stripped.replace(/^E/, 'Mi')
          break
        case /^F/.test(stripped):
          stripped = stripped.replace(/^F/, 'Fa')
          break
        case /^G/.test(stripped):
          stripped = stripped.replace(/^G/, 'Sol')
          break
        default:
          break
      }
      switch (true) {
        case /\/A[b#]?$/.test(stripped):
          stripped = stripped.replace(/\/A([b#]?)$/, '/La$1')
          break
        case /\/B[b#]?$/.test(stripped):
          stripped = stripped.replace(/\/B([b#]?)$/, '/Si$1')
          break
        case /\/C[b#]?$/.test(stripped):
          stripped = stripped.replace(/\/C([b#]?)$/, '/Do$1')
          break
        case /\/D[b#]?$/.test(stripped):
          stripped = stripped.replace(/\/D([b#]?)$/, '/Ré$1')
          break
        case /\/E[b#]?$/.test(stripped):
          stripped = stripped.replace(/\/E([b#]?)$/, '/Mi$1')
          break
        case /\/F[b#]?$/.test(stripped):
          stripped = stripped.replace(/\/F([b#]?)$/, '/Fa$1')
          break
        case /\/G[b#]?$/.test(stripped):
          stripped = stripped.replace(/\/G([b#]?)$/, '/Sol$1')
          break
        default:
          break
      }
    }
    return stripped
  },
  _translate: function (string) {
    return window.__(string)
  },
  _frenchChanged: function (newValue, oldValue) {
    if (oldValue !== undefined) {
      window.localStorage.setItem('frenchChords', newValue)
    }
  },
  ready: function () {
    this.set('french', window.localStorage.getItem('frenchChords') === 'true')
  }
})
